export enum EstadoEntidade {
    SemAlteracao = 0,
    Nova = 1,
    Alterada = 2,
    Excluida = 3
}
export enum StatusEnvioExecucao {
    Enviado = 1,
    Pendente = 2,
    FalhaNoEnvio = 3,
    NaoEnviado = 4
}

export const statusEnvioExecucaoOpcoes = [
    { text: "Todos", value: null },
    { text: "Enviadas", value: StatusEnvioExecucao.Enviado },
    { text: "Pendentes", value: StatusEnvioExecucao.Pendente },
    { text: "Falha no envio", value: StatusEnvioExecucao.FalhaNoEnvio },
    { text: "Não enviadas", value: StatusEnvioExecucao.NaoEnviado },
];

export function ehFalhaDeEnvio(status: StatusEnvioExecucao): boolean {
    return status === StatusEnvioExecucao.FalhaNoEnvio || status === StatusEnvioExecucao.NaoEnviado;
}
